import { isEmpty, isNil, map } from 'lodash';
import React, { useContext, useMemo } from 'react';
import utilizationTypes from './model/UtilizationTypes';
import EntityForm from '../../../../../common/components/containers/EntityForm';
import EntityFormFieldSet from '../../../../../common/components/containers/EntityForm/EntityFormFieldSet';
import StatusField from '../../../../../common/components/containers/EntityForm/fields/StatusField';
import EntityNameField from '../../../../../common/components/containers/EntityForm/fields/EntityNameField';
import useTranslation from '../../../../../common/components/utils/Translations/useTranslation';
import { Active } from '../../../../../model/Statuses';
import CheckboxGroupField from '../../../../../common/components/containers/EntityForm/fields/CheckboxGroupField';
import { AssetCategoryTreeContext } from './AssetCategoryTree';
const AssetCategoryForm = ({ node = { id: null }, onCancel, onSubmit, parentNode, }) => {
    const { t } = useTranslation();
    const { assetGroupId } = useContext(AssetCategoryTreeContext);
    const isNew = isNil(node === null || node === void 0 ? void 0 : node.id);
    const initialValues = useMemo(() => {
        const entity = {
            status: Active.value,
            assetGroupId,
        };
        if (!isEmpty(parentNode)) {
            entity.assetFolderId = parentNode === null || parentNode === void 0 ? void 0 : parentNode.id;
        }
        return isNew ? entity : node;
    }, [isNew, node, assetGroupId, parentNode]);
    const _utilizationTypes = useMemo(() => map(utilizationTypes, ({ name, value }) => ({ value, name: t(name) })), [t]);
    return (<>
      <EntityForm entity={initialValues} entityName={`AssetCategoryForm-${isNew ? 'new' : node.id}`} onCancel={onCancel} onSubmit={onSubmit}>
        <EntityFormFieldSet>
          <EntityNameField columns={3} label={t('Asset Category Name')}/>
          <StatusField columns={3} isNew={isNew}/>
        </EntityFormFieldSet>
        <EntityFormFieldSet title={t('Utilization')}>
          <CheckboxGroupField columns={1} itemLabelPropName="name" itemValuePropName="value" name="utilization" options={_utilizationTypes}/>
        </EntityFormFieldSet>
      </EntityForm>
    </>);
};
export default AssetCategoryForm;
